import React from 'react';

import PropTypes from 'prop-types';
import useProvideCubohActionBar from 'hooks/useProvideCubohActionBar';

import CubohActionBarContext from 'context/CubohActionBarContext';

export function CubohActionBarProvider({ children }) {
  const actionBar = useProvideCubohActionBar();
  return (
    <CubohActionBarContext.Provider value={actionBar}>
      {children}
    </CubohActionBarContext.Provider>
  );
}

CubohActionBarProvider.propTypes = {
  children: PropTypes.node,
};
